module.exports = __webpack_public_path__ + "static/media/How to customize email link template for Questionnaire Link.4cb45b72.png";